<div class="header">{{ 'pricingDetailsModal.inStock' | translate }}</div>
<ng-container
  *ngFor="let price of stockPrices"
  [ngTemplateOutlet]="priceTemplate"
  [ngTemplateOutletContext]="{ priceModel: price, pricesFormGroup: stockPricesForm }"
></ng-container>
